import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Empresa } from '../types';

export interface PipelineData {
  ativos: Empresa[];
  lista_recentes: Empresa[];
  counts: Record<string, number>;
}

export function usePipeline() {
  return useQuery({
    queryKey: ['pipeline'],
    queryFn: async () => {
      const res = await n8nFetch<{ pipeline: PipelineData }>('/pipeline');
      return res.pipeline;
    },
    staleTime: 10_000,
  });
}
